import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuth } from './useAuth';

export function useAlertCount(): number {
  const { isAuthenticated } = useAuth();

  const { data } = useQuery({
    queryKey: ['alerts', 'count'],
    queryFn: async () => {
      const { data } = await api.get<{ count: number }>('/alerts/count');
      return data.count;
    },
    enabled: isAuthenticated,
    // Reduced from 60s to 5min; refetch immediately when tab regains focus
    refetchInterval: () => (document.hasFocus() ? 5 * 60_000 : false),
    refetchOnWindowFocus: true,
    placeholderData: 0,
  });

  return data ?? 0;
}
